module.exports = __webpack_public_path__ + "static/media/mem7.21e641a5.webp";